import { render } from "./PrintFooter.vue?vue&type=template&id=25378a34&scoped=true"
import script from "./PrintFooter.vue?vue&type=script&lang=js"
export * from "./PrintFooter.vue?vue&type=script&lang=js"

import "./PrintFooter.vue?vue&type=style&index=0&id=25378a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25378a34"]])

export default __exports__